module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('section', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0.48)), url(' + _vm.set_gallery_banner_image + ')'
    }),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "gw-info-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 gw-info-banner-img "
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 gw-about"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("About " + _vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), (_vm.sellpoint.business_tagline != 'None provided yet') ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_tagline))]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_profile != 'None provided yet') ? _c('p', {
    staticStyle: {
      "white-space": "pre-line",
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_profile))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "gw-contact"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), (_vm.sellpoint.business_address != 'None provided yet') ? _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "contact-us-p"
  }, [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]), _vm._v(" "), _c('p', {
    staticClass: "contact-us-p"
  }, [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("Delivery Information")]), _vm._v(" "), (_vm.sellpoint.business_delivery_information != 'None provided yet') ? _c('p', {
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information))]) : _vm._e()])])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 gw-info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59d5a2df"}!./src/pages/About/template.html
// module id = 198
// module chunks = 1